module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playlist px-5"
  }, [_c('content-top-header', {
    staticClass: "mt-3 black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("Playlists > " + _vm._s("Playlist"))]), _vm._v(" "), _c('div', {
    staticClass: "meta-summary"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v(" " + _vm._s(this.playlist.name))]), _vm._v(" "), (this.playlist.playlist_type == 'tracks') ? _c('span', [_vm._v(_vm._s(this.tracks.length) + "\n      " + _vm._s(_vm._f("pluralize")("track", this.tracks.length)))]) : (this.playlist.playlist_type == 'streams') ? _c('span', [_vm._v(_vm._s(this.streams.length) + "\n      " + _vm._s(_vm._f("pluralize")("stream", this.streams.length)))]) : _vm._e(), _vm._v(" "), (this.playlist.playlist_type == 'products') ? _c('span', [_vm._v(_vm._s(this.products.length) + "\n      " + _vm._s(_vm._f("pluralize")("product", this.products.length)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "mx-1"
  }, [_vm._v("•")])]), _vm._v(" "), (this.playlist.playlist_type == 'tracks') ? _c('div', {
    staticClass: "list-track-view list-track-view-trackCard listings"
  }, _vm._l((this.tracks), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing"
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.parseAlbum,
        "objectIndex": index,
        "hideMoreMenu": "",
        "playlistId": _vm.playlist.id,
        "removeFromPlaylist": _vm.removeFromPlaylist,
        "hideTrackLength": "",
        "displayDuration": ""
      }
    })], 1)
  })) : (this.playlist.playlist_type == 'streams') ? _c('div', {
    staticClass: "list-track-view list-track-view-trackCard listings"
  }, _vm._l((this.streams), function(video, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing"
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video,
        "showUsername": "",
        "playlistId": _vm.playlist.id,
        "removeFromPlaylist": _vm.removeFromPlaylist,
        "hideUser": false,
        "sideTabView": true
      }
    })], 1)
  })) : (this.playlist.playlist_type == 'products') ? _c('div', {
    staticClass: "list-track-view list-track-view-trackCard listings"
  }, _vm._l((this.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing"
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "sideTabView": "",
        "hideOverlay": false,
        "hideOptionCount": "",
        "playlistId": _vm.playlist.id,
        "removeFromPlaylist": _vm.removeFromPlaylist,
        "altMeta": "",
        "noMeta": "",
        "altMetaPrice": ""
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.sharedAlbum,
      "dismiss": _vm.closeShareTrack
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2757306a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Playlists/playlist.vue
// module id = 1653
// module chunks = 180